import { useMutation } from '@tanstack/react-query';
import { request } from '../services/request';

export const useCredentialRenewal = () => {
    return useMutation(async (data: any) => {
        const jsonResponse = await request({
            data,
            method: 'POST',
            endpoint: 'credentials/renew-contact-credential',
        });

        if (!jsonResponse.success) {
            throw new Error(jsonResponse.data.Message || 'Something went wrong');
        }

        return jsonResponse;
    });
};

